import * as React from 'react';
import { CountdownTimer as CountdownTimer$1 } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import '@swc/helpers';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsCountdownTimer = ({ component , page  })=>{
    const { document: documentRef  } = component.getParameters();
    if (!documentRef) {
        return null;
    }
    const documentGetContent = documentRef && page.getContent(documentRef);
    const document = documentGetContent && documentGetContent.getData();
    if (!document || !document.countdown) {
        return null;
    }
    const { countdown: { endDate , countdownText , showCountdown , url , layout  } ,  } = document;
    return /*#__PURE__*/ React.createElement(CountdownTimer$1, {
        endDate: endDate,
        countdownText: countdownText,
        showCountdown: showCountdown,
        url: url,
        layout: layout
    });
};
var CountdownTimer = compose(withHidableContent, withBreakpointVisibility, withBloomreachData, withEditableContent)(CmsCountdownTimer);

export { CmsCountdownTimer, CountdownTimer as default };
//# sourceMappingURL=CountdownTimer.js.map
